import api from './api';

const getPacienteById = async id => {
  const { data } = await api.get(`/pacientes`, { params: { id } });
  return data;
};

export default getPacienteById;
